/**
 * OrcamentosVencendoWidget — Orcamentos cujo status_temporal eh
 * QUASE_PERDIDO (a poucos dias de virar PERDIDO).
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarOrcamentos } from "../../../services/orcamentos";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "orcamentos_vencendo",
  label: "Orçamentos vencendo",
  descricao: "Orcamentos com status temporal QUASE_PERDIDO (acao urgente).",
  categoria: "Pendencias",
  permissoes: ["orcamento:view"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const payload = await listarOrcamentos(request, {
    status_temporal: "QUASE_PERDIDO",
    pageSize: 1,
  });
  const c = Array.isArray(payload) ? payload.length : (payload?.count ?? (payload?.results || []).length);
  return { qtd: c };
}

export function Widget({ dados }) {
  const c = dados?.qtd ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: c > 0 ? "var(--warning-text)" : undefined }}>{c}</KpiValor>
        <KpiSub>
          {c > 0
            ? "orçamentos quase perdidos — follow-up urgente"
            : "Nenhum orçamento em risco."}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/orcamentos">Ver orçamentos</LinkLight>
      </CardFooter>
    </>
  );
}
